import { Record } from 'immutable'
import { IAssociatedContact } from './AssociatedContact'

export interface IChatRecipient extends IAssociatedContact {
  readonly lastSeenTimestamp?: number
}

const ChatRecipientRecord = Record({
  contactId: '',
  isCompany: false,
  lastSeenTimestamp: undefined,
  name: '',
})

export class ChatRecipient extends ChatRecipientRecord
  implements IChatRecipient {
  public static fromJS(initialState?: Partial<IChatRecipient>) {
    if (!initialState) {
      return new ChatRecipient()
    }

    const { ...rest } = initialState

    return new ChatRecipient({
      ...rest,
    })
  }

  public readonly lastSeenTimestamp?: number
  public readonly contactId: string
  public readonly isCompany: boolean
  public readonly name: string

  constructor(initialState?: Partial<ChatRecipient>) {
    initialState ? super(initialState) : super()
  }
}
